import { Injectable } from '@angular/core';
import { TAppMaster } from '@monorepo/resolvers';
import { TRESPONSE_LotListing } from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { LoadMasterData, loadMasterDataByMasterList } from './master-data-db.actions';
import { selectMasterDataMapByBundleId, selectAllBundles, isMasterDataDBReady } from './master-data-db.query';

type TMasterDataDefaultListType = 'fabric_knit_defect_list' | 'fabric_woven_defect_list';
@Injectable({
  providedIn: 'root',
})
export class MasterDataDBFacade {
  constructor(private store: Store<TAppMaster>) {}

  loadMasterData() {
    this.store.dispatch(new LoadMasterData());
  }

  loadMasterDataByMasterList(masterList: string[] = [], updateSyncingStatus: boolean, showLoader: boolean) {
    this.store.dispatch(new loadMasterDataByMasterList(masterList, updateSyncingStatus, showLoader));
  }

  isMasterDataDBReady() {
    return this.store.pipe(select(isMasterDataDBReady));
  }

  getMasterDataAllBundle() {
    return this.store.pipe(select(selectAllBundles));
  }
  getMasterDataMapForSelectedBundle() {
    return this.store.pipe(select(selectMasterDataMapByBundleId));
  }

  getMasterDataByFabricVariant(fabricVarient: TRESPONSE_LotListing['items'][number]['metadata']['fabricVariant']) {
    const keyName = fabricVarient === 'KNIT' ? 'fabric_knit_defect_list' : 'fabric_woven_defect_list';
    return this.store.pipe(
      select(selectAllBundles),
      map((v) => v['default'].data[keyName]),
    );
  }

  getMasterDataByListName(listName: string) {
    return this.store.pipe(
      select(selectAllBundles),
      map((v) => v['default'].data[listName]),
    );
  }
}

export type TIsMasterDataDBReady = ReturnType<MasterDataDBFacade['isMasterDataDBReady']>;
export type TGetMasterDataMapForSelectedBundle = ReturnType<MasterDataDBFacade['getMasterDataMapForSelectedBundle']>;
export type TGetMasterDataAllBundle = ReturnType<MasterDataDBFacade['getMasterDataAllBundle']>;
export type TGetMasterDataByFabricVariant = ReturnType<MasterDataDBFacade['getMasterDataByFabricVariant']>;
